import { useCallback, useMemo, useState } from 'react'

import { AssignmentStage } from 'constants/assignment'
import constate from 'constate'
import { AssignmentDTO } from 'models/assignment'
import { useGalleryDeal } from '../../_main/contexts'
import { useGalleryStagingFlow } from '../GalleryStagingFlow'

/** Helper function, that returns whether assignment is in correct stage for staging */
export const _isStagingAvailable = (assignmentStage: AssignmentStage) => {
  return [AssignmentStage.MISSION_ORDER_PLACED, AssignmentStage.PRE_PRODUCTION].includes(assignmentStage)
}

export const [AvailableStagingsListContextProvider, useAvailableStagingsList] = constate(() => {

  const { stagingAssignments } = useGalleryDeal()
  const { stagingRequestState } = useGalleryStagingFlow()

  const [assignmentsToStage, setAssignmentsToStage] = useState<AssignmentDTO[]>([])
  const [finishedStagings, setFinishedStagings] = useState<Set<string>>(new Set([]))
  const [skipStaging, setSkipStaging] = useState(false)

  const hasStaging = useMemo(() => assignmentsToStage.length > 0, [assignmentsToStage.length])
  const isStagingFinished = useMemo(() => skipStaging || assignmentsToStage.length === finishedStagings.size, [assignmentsToStage.length, finishedStagings.size, skipStaging])
  const remainingStagingsCount = useMemo(() => assignmentsToStage.length - finishedStagings.size, [assignmentsToStage.length, finishedStagings.size])

  /** Initialize context with filtered assignments ready for staging */
  const initializeStaging = useCallback(() => {
    const assignmentsToSet = stagingAssignments.filter((assignment) => _isStagingAvailable(assignment.stage))
    setAssignmentsToStage(assignmentsToSet)
  }, [stagingAssignments])

  /** Resets staging data */
  const resetStaging = () => {
    setAssignmentsToStage([])
    setFinishedStagings(new Set([]))
    setSkipStaging(false)
  }

  return {
    hasStaging,
    isStagingFinished,
    stagingRequestState,
    finishedStagings,
    assignmentsToStage,
    remainingStagingsCount,
    skipStaging,
    setFinishedStagings,
    initializeStaging,
    resetStaging,
    setSkipStaging,
  }

})
